<template>
    <div class="container-fluid unPaidReg" style="margin-top: 5rem;">
        <v-row justify="center">
            <v-col class="py-0">
                <v-row class="py-0">
                    <v-col class="pl-3" v-if="!loadingPage">
                        <v-row v-if="menu.length != 0">
                            <v-col class="py-0" style="line-height: 20px; padding: 0% 5% 0% 5%;">
                                 <v-row :style="`color:${danger}`">
                                    <v-col md="1" cols="12"></v-col>
                                    <v-col md="10" cols="12" style="text-align: center;">
                                        <h2>{{ $t('unPaidRegistration.warning') }}</h2>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col md="1" cols="12"></v-col>
                                    <v-col md="10" cols="12" style="text-align: center;">
                                        <h2>{{ total == 0 ? $t('unPaidRegistration.warning_text1_free') : $t('unPaidRegistration.warning_text1') }}</h2>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col md="1" cols="12"></v-col>
                                    <v-col md="10" cols="12" style="text-align: center;">
                                        <h2>{{ total == 0 ? $t('unPaidRegistration.warning_text3_free') : $t('unPaidRegistration.warning_text3') }}</h2>
                                    </v-col>
                                </v-row>
                                <br>
                                <v-row justify="center">
                                    <v-expansion-panels accordion multiple v-model="panel" style="width:90%;">
                                        <v-expansion-panel 
                                            v-for="(item,i) in menu" :key="i"
                                            style="margin-bottom: 10px;">
                                            <v-expansion-panel-header 
                                                class="my-1" 
                                                :style="`background-color: ${navigationBGColor} !important;`"
                                                dark>
                                                <p depressed
                                                class="font-weight-bold text-left white--text text-uppercase"
                                                style="color: #fff !important; margin-bottom:0px"
                                                >{{ item.promoterName }} :: {{ item.eventDate }} :: {{ item.eventName}}</p>
                                            </v-expansion-panel-header>
                                            <v-expansion-panel-content>
                                                
                                                <v-expansion-panels accordion multiple :value="[0]">
                                                    <v-expansion-panel>
                                                        <v-expansion-panel-header 
                                                            class="my-1"
                                                            :style="`background-color: ${navigationBGColor} !important`"
                                                            dark>
                                                            <p depressed
                                                            class="font-weight-bold text-left white--text text-uppercase"
                                                            style="color: #fff !important; margin-bottom:0px"
                                                            >{{ $t('unPaidRegistration.transaction_summary') }}</p>
                                                        </v-expansion-panel-header>
                                                        <v-expansion-panel-content>
                                                            <Summary ref="summary" :eventId="item.eventId" :regId="item.id" :discount="item.idCoupon ? item : null"></Summary>
                                                        </v-expansion-panel-content>
                                                    </v-expansion-panel>
                                                </v-expansion-panels>
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    </v-expansion-panels>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row v-if="menu.length == 0">
                            <v-col class="py-0">
                                <v-row class="px-1">
                                    <v-col justify="center">
                                        <h2 style="text-align: center;">{{ $t('unPaidRegistration.incomplete_registration') }}</h2>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
        </v-col>
        </v-row>         
    </div>
</template>

<script>
import Summary from "../components/unPaidRegistration/Summary.vue";
import PaymentService from "../services/PaymentService";
import AuthService from "../services/AuthService";
import { VRow, VCol, VExpansionPanels, VExpansionPanel, VExpansionPanelHeader, VExpansionPanelContent } from 'vuetify/lib';
import { mapState } from "vuex";

export default {
    components: {
        Summary,
        VRow, VCol, VExpansionPanel, VExpansionPanelHeader, VExpansionPanelContent, VExpansionPanels 
    },
    data() {
        return {
            navigationBGColor: null,
            buttonColor: null,
            danger: null,
            menu: [],
            userId: null,
            panel: [],
            QueueId: null, total: 0  
        };
    },
    computed: {
        ...mapState({
            loadingPage: state => {
                if(state && state.session) return state.session.loadingPage;
                return true;
            }
        }),
    },
    mounted() {
        
    },
    methods: {
        async obtenerTotal() {
            await PaymentService.getPrice(this.menu[0].eventId).then(response => {
                this.total = response.data;
            });
        },
        async getUser(){
            await AuthService.getUserCurrent().then(response => {
                if (response.data.success == 1) {
                    this.userId = response.data.message.id;
                    /*let imgUser = response.data.message.existFile 
                        ? this.$store.getters.env.get('VUE_APP_DEV_API_HOST')+"/laravel/public"+response.data.message.image 
                        : require("@/assets/images/partPlaceholder.jpg")
                        ? this.$store.getters.env.get('VUE_APP_DEV_API_HOST') + response.data.message.image
                        : require("@/assets/images/partPlaceholder.jpg");
                    this.$emit("imageUser", imgUser);*/
                    this.getUnpaid();
                }
            });
        },
        async getUnpaid() {
            await PaymentService.unpaid(this.userId).then(response => {
                if(response.data.success == 1){  
                    this.menu = response.data.message;
                    this.obtenerTotal();
                    this.panel = [...Array(this.menu.length).keys()].map((k, i) => i);
                    this.$store.dispatch('setLoadingPageAction',false);
                }
            });
        }
    },
    created: function() {
        this.navigationBGColor = this.$store.getters.env.get('VUE_APP_BUTTON_COLOR');
        this.buttonColor = this.$store.getters.env.get('VUE_APP_BUTTON_COLOR');
        this.danger = this.$store.getters.env.get('VUE_APP_BUTTON_DANGER_COLOR');
        this.getUser();
    }
};
</script>

<style>

.unPaidReg .v-expansion-panel--active>.v-expansion-panel-header {
    height: 40px;
}
.unPaidReg .v-expansion-panel--active>.v-expansion-panel-header {
    min-height: 40px;
}
.unPaidReg .v-data-table>.v-data-table__wrapper>table>tbody>tr>th, 
.unPaidReg .v-data-table>.v-data-table__wrapper>table>tfoot>tr>th, 
.unPaidReg .v-data-table>.v-data-table__wrapper>table>thead>tr>th {
    height: 30px;
}
.unPaidReg .v-data-table>.v-data-table__wrapper>table>tbody>tr>td, 
.unPaidReg .v-data-table>.v-data-table__wrapper>table>tfoot>tr>td, 
.unPaidReg .v-data-table>.v-data-table__wrapper>table>thead>tr>td {
    height: 30px;
}

.btn_next{
    margin-right: 10px;
}
.buttons{
    float:right; 
    text-align:right
}
@media (max-width: 1024px) {
  .btn_next{ margin-right: 0px;}
  .buttons{ text-align:center}
}
</style>